import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  root: {
    minHeight: 'calc(100vh - 80px)',
  },
});
